import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {ConfigModule, I18nModule} from '@spartacus/core';
import {DcpCartCouponComponent} from '@app/shared/coupon/dcp-cart-coupon.component';
import {DcpAppliedCouponsComponent} from '@app/shared/coupon/applied-coupons/dcp-applied-coupons.component';
import {ReactiveFormsModule} from '@angular/forms';
import {FormErrorsModule} from '@spartacus/storefront';
import {CommonModule} from '@angular/common';
import {InputModule} from 'ng-design-system';

import '@udex/web-components/dist/Button';
import '@udex/web-components/dist/TextField';
import '@ui5/webcomponents/dist/Icon';

@NgModule({
  declarations: [DcpCartCouponComponent, DcpAppliedCouponsComponent],
  imports: [
    CommonModule,
    ConfigModule.withConfig({
      cmsComponents: {
        CartCouponComponent: {
          component: DcpCartCouponComponent,
        },
      },
    }),
    ReactiveFormsModule,
    FormErrorsModule,
    I18nModule,
    InputModule,
  ],
  exports: [
    DcpCartCouponComponent,
    DcpAppliedCouponsComponent,
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
  ],
})
export class DcpCartCouponModule {
}
